import type { AxiosPromise } from 'axios';
import type { Payload } from '@/api/interfaces/payload';
import httpClient from '@/helpers/client/http-client';

interface UnreadInboxCount {
  unreadInboxCount: number;
}

export function getUnreadInboxCount(
  abortController: AbortController = new AbortController(),
): AxiosPromise<Payload<UnreadInboxCount['unreadInboxCount']>> {
  return httpClient.get('/definitions/unread-inbox-count', {
    signal: abortController.signal,
  }).then((response) => ({
    ...response,
    data: {
      ...response.data,
      data: response.data.data.unreadInboxCount,
    },
  }));
}
